import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="loading-spinner-container" [ngClass]="'size-' + size">
      <div class="spinner"></div>
      <p *ngIf="message" class="loading-message">{{ message }}</p>
    </div>
  `,
  styles: [`
    .loading-spinner-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 24px;
      background: transparent;
    }

    .spinner {
      border: 3px solid rgba(229, 0, 0, 0.1);
      border-top: 3px solid #E50000;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    .size-small .spinner {
      width: 24px;
      height: 24px;
      border-width: 2px;
    }

    .size-medium .spinner {
      width: 40px;
      height: 40px;
    }

    .size-large .spinner {
      width: 60px;
      height: 60px;
      border-width: 4px;
    }

    .loading-message {
      margin-top: 12px;
      color: #666;
      font-size: 14px;
      text-align: center;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `]
})
export class LoadingSpinnerComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() message: string = '';
}
